import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { Observable } from 'rxjs';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
//import { ProductoServicio, UnidadMedida } from 'app/interfaces';
import { debounceTime, map, startWith } from 'rxjs/operators';

export interface IPartePedimento {
    index: string;
    id: number;
    pedimento: string;
    title: string;
}

interface CaracteristicasInput {
    hidden?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    required?: boolean;
    placeholder?: string;
}

@Component({
    selector: 'app-mercancias',
    templateUrl: './mercancias.component.html',
    styleUrls: ['./mercancias.component.scss']
})
export class MercanciasComponent implements OnInit {
    //@OUTPUTS
    @Output() FormMercanciaEventEmiter = new EventEmitter<any>();
    //@INPUTS
    @Input() idOperacion: any;
    @Input() tipoTransporte: any;
    @Input() title: any;
    @Input() peso: any;
    @Input() idMercancia: any;
    @Input() idMovimiento?: any;

    //variables de subformularios
    removeDisabledGuiaI: boolean = true;
    removeDisabledTransporte: boolean = true;
    removeDisabledGuiaP: boolean = true;
    submitted = false;
    countGuiasI: any = [];
    countGuiasP: IPartePedimento[] = [];
    countTransporte: any = [];
    //Formularios
    mercancias: any[];
    mpeligrosos: any = [{ id: 1, nombre: 'No' }, { id: 2, nombre: 'Si' }]
    embalajes: [];
    monedas: any[] = [];

    FormMercancia = new FormGroup({
        mercancia: new FormControl(0),
        nombre: new FormControl(''),
        cBienes: new FormControl('', [Validators.required]),
        claveBienes: new FormControl('', [Validators.required]),
        dBienes: new FormControl('', [Validators.required]),
        cUnidad: new FormControl('', [Validators.required]),
        unidad: new FormControl(''),
        mPeligroso: new FormControl(0),
        cveMPeligroso: new FormControl(''),
        emabalaje: new FormControl(0),
        pesokg: new FormControl('', [Validators.required]),
        valorM: new FormControl(''),
        Dimen: new FormControl(''),
        moneda: new FormControl(),
        fArancelaria: new FormControl(''),
        uuidComercio: new FormControl('', [
            Validators.pattern('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$')
        ]),
        idOperacion: new FormControl(0),
    });
    //listas para guardar
    //PEDIMENTOS
    pedimentosList: any[] = [];
    pedimentosIds: number[] = [];
    defualtPedimento: IPartePedimento = { index: `PartePedimento${this.countGuiasP.length + 1}`, id: 0, pedimento: '', title: `Pedimento ${this.countGuiasP.length + 1}` };
    guiatransportelist: any[] = [];
    guiaidentificacionlist: any[] = [];

    rulMaterialPeligroso: CaracteristicasInput = {
        disabled: true
    };

    rulcveMaterialPeligroso: CaracteristicasInput = {
        disabled: true
    };

    rulEmbalaje: CaracteristicasInput = {
        disabled: true
    };

    //options: any;
    //filteredOptions: Observable<ProductoServicio[]>;
    /*
        lstClaveBienes: any[] = [];
        opcionesFiltradasClaveBienes: Observable<any[]>;
    
        opcionesFiltradasCUnidad: Observable<any[]>;
        lstUnidadPeso: any[] = [];
    
        */
    opcionesFiltradasMonedas: Observable<any[]>;

    claveUnidadSelected: any;

    idEmpresa: number;
    idsIdentificacion = [];
    idsTransporte = [];
    claveSAT: any = { eje: '2' };
    optionSAT: any[] = [];

    isValidUnidad: boolean = false;
    isValidClave: boolean = false;
    rowsetshowClave: boolean = false;
    rowsetshowUnidad: boolean = false;
    myControlUnidadMedida = new FormControl('', [Validators.required]);
    myControl = new FormControl('', [Validators.required]);
    unidadMedida: any[] = [];
    unidad_Medida: any[] = [];

    constructor(
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        private sharedService: SharedService,
        private renderer: Renderer2
    ) {
        this.store.select(selectUtilsState).subscribe((state: any) => {
            if (this.idEmpresa !== state.empresaSeleccionada.id) {
                this.idEmpresa = state.empresaSeleccionada.id;
            }
        });

        this.displayFn = this.displayFn.bind(this);
        this.displayFnUnidadMedida = this.displayFnUnidadMedida.bind(this);
    }

    async ngOnInit(): Promise<void> {
        //console.log("🚀 ~ MercanciasComponent ~ ngOnInit ~ this.idMercancia:", this.idMercancia)
        if (this.idMercancia == null || this.idMercancia == undefined || this.idMercancia == '')
            this.idMercancia = 0;

        this.senddata();
        this.selMonedas();
        const rm = await this.getMercancias();
        this.selSelectsData();
        //this.GetClaveBienes();
        //this.GetCatalogoImpuestos();
        //Set data Pedimentos
        this.sharedService.pedimentos$.subscribe(valores => {
            const index = this.pedimentosList.findIndex(item => item && item.index === valores.index && item.pedimento === valores.pedimento);
            if (index === -1) {
                if (valores) this.pedimentosList.push(valores);
            } else {
                if (valores) this.pedimentosList[index] = valores;
            }
        });
        //this.selEmbalaje();
        //this.selMpeligroso();

        this.FormMercancia.controls['mPeligroso'].disable();
        this.FormMercancia.controls['cveMPeligroso'].disable();
        this.FormMercancia.controls['emabalaje'].disable();
        //Autocomplete
        //this.myControl.disable();
        //this.myControlUnidadMedida.disable();

    }//Fin Init

    displayFn(id: any): string {
        if (id && id?.attributes) {
            const clave = id?.attributes?.clave || '';
            const descripcion = id?.attributes?.descripcion || '';
            return `${clave}-${descripcion}`;
        }
    }
    displayFnUnidadMedida(id: any): string {
        if (id && id?.attributes) {
            const clave = id?.attributes?.clave || '';
            const descripcion = id?.attributes?.descripcion || '';
            return `${clave}-${descripcion}`;
        }
    }

    private _filtrarMonedas(value: string): any[] {
        const filterValue = value ? value.toLowerCase() : '';
        return this.monedas.filter(moneda =>
        (moneda?.attributes?.clave?.toLowerCase()?.includes(filterValue) ||
            moneda?.attributes?.descripcion?.toLowerCase()?.includes(filterValue))
        );
    }

    get f() {
        return this.FormMercancia.controls;
    }
    btnClave() {
        window.open('http://200.57.3.89/PyS/catPyS.aspx', '_blank');
    }

    btnUnidad() {
        window.open('http://200.57.3.89/PyS/catUnidades.aspx', '_blank');
    }

    displayFnMoneda = (moneda: any): string => {
        const monedaEncontrada = this.monedas.find((f: any) => f.id === moneda);
        if (monedaEncontrada) {
            return `${monedaEncontrada.attributes.clave} - ${monedaEncontrada.attributes.descripcion}`;
        } else {
            return '';
        }
    }

    onUnidadMedidaSelected(value): void {
        console.log("🚀 ~ MercanciasComponent ~ onUnidadMedidaSelected ~ value:", value)
        let idUnidad = value?.id || null;
        let descUnidad = value?.attributes?.descripcion || null;
        let isPeligroso = Boolean(value?.attributes?.materialPeligroso || false);
        //Unidad
        //this.claveUnidadSelected = this.lstUnidadPeso.find((f: any) => f.id === e.option.value);
        this.FormMercancia.controls['cUnidad'].setValue(idUnidad);
        this.FormMercancia.controls['unidad'].setValue(descUnidad);
        //Material peligroso
        if (isPeligroso) {
            this.FormMercancia.controls['mPeligroso'].enable();
            this.FormMercancia.controls['mPeligroso'].setValue(2)
        } else {
            this.FormMercancia.controls['mPeligroso'].disable();
            this.FormMercancia.controls['mPeligroso'].setValue(1)
        }
    }

    selectedProductoServicio(value) {
        console.log("🚀 ~ MercanciasComponent ~ selectedProductoServicio ~ value:", value)
        let idBien = value?.id || null;
        let descBien = value?.attributes?.descripcion || null;
        this.FormMercancia.controls['claveBienes'].setValue(idBien);
        this.FormMercancia.controls['dBienes'].setValue(descBien);

    }
    eraseUnidad() {
        this.rowsetshowUnidad = false;
        this.myControlUnidadMedida.reset();

        this.isValidUnidad = false;
        this.myControlUnidadMedida.setValue(null);

        setTimeout(() => {
            // this.myInputClave.nativeElement.focus();
            var element = this.renderer.selectRootElement(
                '#myInputBusquedaUnidad'
            );
            element.focus();
        }, 500);
    }

    eraseClaveSat() {
        this.rowsetshowClave = false;
        this.myControl.reset();
        //Bienes mercancia
        this.FormMercancia.controls['claveBienes'].setValue(null);
        this.FormMercancia.controls['dBienes'].setValue(null);

        this.isValidClave = false;
        this.myControl.setValue(null);

        this.rulMaterialPeligroso.disabled = true;
        this.rulcveMaterialPeligroso.disabled = true;
        this.rulEmbalaje.disabled = true;

        this.FormMercancia.controls['mPeligroso'].setValue(0)
        this.FormMercancia.controls['cveMPeligroso'].setValue('')
        this.FormMercancia.controls['emabalaje'].setValue(0)

        this.FormMercancia.controls['mPeligroso'].disable();
        this.FormMercancia.controls['cveMPeligroso'].disable();
        this.FormMercancia.controls['emabalaje'].disable();

        setTimeout(() => {
            // this.myInputClave.nativeElement.focus();
            var element = this.renderer.selectRootElement('#myInputBusquedaClave');
            element.focus();
        }, 500);
    }

    fnMaterialPeligroso(event: any) {
        if (event == 2) { // Si
            this.FormMercancia.controls['cveMPeligroso'].enable();
            this.FormMercancia.controls['emabalaje'].enable();
        }
        else { // No
            this.FormMercancia.controls['cveMPeligroso'].setValue('')
            this.FormMercancia.controls['emabalaje'].setValue(0)

            this.FormMercancia.controls['cveMPeligroso'].disable();
            this.FormMercancia.controls['emabalaje'].disable();
        }
    }

    claveProdSeleccionado(event: any) {
        const selectedValue = event.option.value; // Aquí obtienes el valor seleccionado

        if (selectedValue.materialPeligroso) {
            this.rulMaterialPeligroso.disabled = false;
            this.rulcveMaterialPeligroso.disabled = false;
            this.rulEmbalaje.disabled = false;

            this.FormMercancia.controls['mPeligroso'].setValue(2)

            this.FormMercancia.controls['mPeligroso'].enable();
            this.FormMercancia.controls['cveMPeligroso'].enable();
            this.FormMercancia.controls['emabalaje'].enable();

        }
        else {
            this.rulMaterialPeligroso.disabled = true;
            this.rulcveMaterialPeligroso.disabled = true;
            this.rulEmbalaje.disabled = true;

            this.FormMercancia.controls['mPeligroso'].setValue(3)
            this.FormMercancia.controls['cveMPeligroso'].setValue('')
            this.FormMercancia.controls['emabalaje'].setValue(0)


            this.FormMercancia.controls['mPeligroso'].disable();
            this.FormMercancia.controls['cveMPeligroso'].disable();
            this.FormMercancia.controls['emabalaje'].disable();
        }
    }

    selSelectsData() {
        this.srvcoal.getService(`cat-embalajes?populate=*&pagination[start]=0&pagination[limit]=54000`).subscribe((res: any) => {
            // this.store.dispatch(OcultarSpinner());
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.embalajes = res.data;

            }
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            //this.store.dispatch(OcultarSpinner())
        });
    }

    selMonedas() {
        // let data;
        this.srvcoal.getService(`cat-monedas?populate=*&pagination[start]=0&pagination[limit]=54000`).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                this.monedas = res?.data || [];
                this.FormMercancia.controls.moneda.setValue(1);

                this.opcionesFiltradasMonedas = this.FormMercancia.get('moneda').valueChanges.pipe(
                    startWith(''),
                    map(value => {
                        const name = typeof value === 'string' ? value : value?.name;
                        return name ? this._filtrarMonedas(name as string) : this.monedas.slice();
                    }),
                );

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    selExtras(mercancia) {
        this.asignarExtrasGuiasI(mercancia?.attributes?.fac_porte_mer_idens);
        this.asignarExtrasGuiasT(mercancia?.attributes?.fac_porte_mer_cantidads);
        //Pedimentos
        let listaPedimentos = mercancia?.attributes.fac_porte_pedimentos?.data || [];
        this.asignarExtrasGuiasP(listaPedimentos);
    }

    asignarExtrasGuiasI(data) {
        this.countGuiasI = [];
        const sortedData = data.data.sort((a, b) => a.id - b.id);
        for (var i = 0; i <= sortedData.length - 1; i++) {
            let datos = {
                NumeroGuiaIdentificacion: sortedData[i].attributes.numeroGuiaIdentificacion,
                DescripGuiaIdentificacion: sortedData[i].attributes.descripGuiaIdentificacion,
                PesoGuiaIdentificacion: sortedData[i].attributes.pesoGuiaIdentificacion,
            }
            this.countGuiasI.push({ id: `Guias Idenfificacion ` + (i + 1), data: datos });
        }
    }

    asignarExtrasGuiasT(data) {
        this.countTransporte = [];
        const sortedData = data.data.sort((a, b) => a.id - b.id);

        for (var i = 0; i <= sortedData.length - 1; i++) {
            let datos = {
                cantidad: sortedData[i].attributes.cantidad,
                idOrigen: sortedData[i].attributes.IDOrigen,
                idDestino: sortedData[i].attributes.IDDestino,
            }
            this.countTransporte.push({ id: `Cantidad Transporta ` + (i + 1), data: datos });
        }
    }

    asingdataForm(value) {
        //console.log("🚀 ~ MercanciasComponent ~ asingdataForm ~ value:", value)

        this.idMercancia = Number(value || 0);
        if (this.idMercancia > 0) {
            this.SelectedMercanciaById(this.idMercancia);
        } else {
            this.countGuiasP = [];
            this.pedimentosList = [];
            this.pedimentosIds = [];
            this.FormMercancia.reset();
            this.countGuiasI = [];
            this.countTransporte = [];
            this.idMercancia = null;
            this.eraseClaveSat();
            this.eraseUnidad();
            //const rm = await this.getMercancias();
            this.idMercancia = 0;
            this.FormMercancia.controls['mercancia'].setValue(this.idMercancia);
        }

    }

    async DelMercancia() {

        //Eliminacion Logica de pedimentos
        if (this.idMercancia == null || this.idMercancia == undefined || this.idMercancia == 0) {
            return this._snackBar.open(
                'Favor de seleccionar la Mercancia a eliminar',
                'OK',
                { duration: 5000 }
            );
        }

        //Existen Pedimentos
        if (this.countGuiasP.length > 0) {
            for await (const item of this.countGuiasP) {
                if (item.id > 0) {//draft
                    const res = await this.logicalDeletePortePedimento(item.id);
                }
            }
            //Pedimentos
            this.countGuiasP = [];
            this.pedimentosList = [];
            this.pedimentosIds = [];
            this.removeDisabledGuiaP = true;
        }

        let body = {
            data: {
                publishedAt: null
            }
        }
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.putService(`fac-porte-mercancias/${this.idMercancia}`, body).subscribe(async (res: any) => {
            this.store.dispatch(OcultarSpinner());
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
            } else {
                this.FormMercancia.reset();
                this.countGuiasI = [];
                this.countTransporte = [];

                //Pedimentos
                this.countGuiasP = [];
                this.pedimentosList = [];
                this.pedimentosIds = [];
                this.removeDisabledGuiaP = true;

                const rm = await this.getMercancias();

                this.idMercancia = 0;
                this.FormMercancia.controls['mercancia'].setValue(this.idMercancia);
                return this._snackBar.open("Eliminacion Exitoso", 'Ok', { duration: 10000 });
            }
        },
            (error: any) => {
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                this.store.dispatch(OcultarSpinner());
            });
    }

    getMercancias(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate[fac_porte_mercancias][populate]= *`).subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                //console.log("🚀 ~ MercanciasComponent ~ SelMercancia ~ res:", res)
                if (res.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                } else {
                    this.mercancias = res?.data[0]?.attributes?.fac_porte_mercancias?.data || [];
                }
                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    this.store.dispatch(OcultarSpinner());
                    resolve(false);
                });

        });
    }

    SelectedMercanciaById(id: number) {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`fac-porte-mercancias/${id}?populate=*`).subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            //console.log("🚀 ~ MercanciasComponent ~ this.srvcoal.getService ~ SelectedMercanciaById:", res)
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
            } else {
                let value: any = res?.data || {};
                if (value?.id) {
                    //Set Form
                    //Bienes mercancia
                    let objClaveSat = value?.attributes?.cat_clave_sat?.data || {};
                    let idClaveSat = Number(objClaveSat?.id || 0);
                    let claveDesc = value?.attributes?.descripcion || null;
                    if (idClaveSat > 0 && claveDesc) {
                        this.optionSAT = [];
                        this.claveSAT = [];
                        objClaveSat.attributes.nombre = objClaveSat?.attributes?.descripcion || '';
                        this.optionSAT.push(objClaveSat);
                        this.claveSAT.push(objClaveSat);
                        //Buscando... 
                        //let strDec= String(claveDesc).split(' ');
                        //let str1= strDec[0]||'';
                        // const resclave = await this.getProductoServicio(str1)
                        this.FormMercancia.patchValue({
                            claveBienes: '' + idClaveSat
                        });
                        this.isValidClave = true;
                        this.rowsetshowClave = true;
                        this.myControl.setValue(objClaveSat);
                    }

                    // Unidad mercancia
                    let objUnidad = value.attributes.cat_unidad.data || {};
                    let idClaveUnidad = Number(objUnidad?.id || 0);
                    if (idClaveUnidad > 0) {
                        this.unidadMedida = [];
                        this.unidad_Medida = [];
                        this.rowsetshowUnidad = true;
                        this.isValidUnidad = true;
                        objUnidad.attributes.descripcion = objUnidad?.attributes?.nombre || '';
                        this.unidadMedida.push(objUnidad);
                        this.unidad_Medida.push(objUnidad);
                        this.FormMercancia.patchValue({
                            cUnidad: '' + idClaveUnidad
                        });
                        this.myControlUnidadMedida.setValue(objUnidad);
                    }
                    this.FormMercancia.controls.nombre.setValue(value.attributes.nombre);
                    this.FormMercancia.controls.cBienes.setValue(value.attributes.cantidadBienes);
                    //this.FormMercancia.controls.claveBienes.setValue();
                    this.FormMercancia.controls.dBienes.setValue(value.attributes.descripcion);
                    //this.FormMercancia.controls.cUnidad.setValue();
                    this.FormMercancia.controls.unidad.setValue(value.attributes.cat_unidad.data.attributes.nombre);
                    this.FormMercancia.controls.mPeligroso.setValue(value?.attributes?.materialPeligroso == false ? 1 : 2);
                    this.FormMercancia.controls.cveMPeligroso.setValue(value?.attributes?.CveMaterialPeligroso);
                    this.FormMercancia.controls.emabalaje.setValue(value?.attributes?.cat_embalaje?.data ? value?.attributes?.cat_embalaje?.data?.id : null);
                    this.FormMercancia.controls.pesokg.setValue(value?.attributes?.pesoKg);
                    this.FormMercancia.controls.valorM.setValue(value?.attributes?.valorMercancia);
                    this.FormMercancia.controls.Dimen.setValue(value?.attributes?.dimenciones);
                    this.FormMercancia.controls.moneda.setValue(value?.attributes?.cat_moneda?.data ? value?.attributes?.cat_moneda?.data?.id : null);
                    this.FormMercancia.controls.fArancelaria.setValue(value?.attributes?.FraccionArancelaria);
                    this.FormMercancia.controls.uuidComercio.setValue(value?.attributes?.uuidComercio);
                    this.selExtras(value);

                }
            }
        },
            (error: any) => {
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                this.store.dispatch(OcultarSpinner());
            });
    }

    async saveMercancia() {
        this.submitted = true;
        if (!this.FormMercancia.valid)
            return this._snackBar.open(
                'Favor de completar los datos requeridos',
                'OK',
                { duration: 5000 }
            );

        if (!this.myControl.valid)
            return this._snackBar.open(
                'Favor de asignar una Clave Bienes',
                'OK',
                { duration: 5000 }
            );

        if (!this.myControlUnidadMedida.valid)
            return this._snackBar.open(
                'Favor de asignar una Clave Unidad',
                'OK',
                { duration: 5000 }
            );

        // this.FormMercancia.value.idOperacion = this.idOperacion;
        //Forms contenedor parte trans porte            
        this.pedimentosIds = [];
        if (this.pedimentosList.length > 0) {
            //Save Or Update Contenedores
            for await (const item of this.pedimentosList) {
                if (item.id > 0) {//Update
                    const res = await this.updatePortePedimento(item.id, item.pedimento);
                } else { //Save
                    const res = await this.savePortePedimento(item.pedimento);
                }
            }
        }
        //Bienes
        let idBien = this.FormMercancia.get('claveBienes').value || null;
        let descBien = this.FormMercancia.get('dBienes').value || null;
        //Unidad
        let idUnidad = this.FormMercancia.get('cUnidad').value || null;
        let descUnidad = this.FormMercancia.get('unidad').value || null;
        //Clave Peligroso
        let cvePeligroso = this.FormMercancia.get('cveMPeligroso').value || null;
        let bodyMercancia = {
            data: {
                nombre: this.FormMercancia.get('nombre').value || null,
                cantidadBienes: this.FormMercancia.get('cBienes').value || null,
                cat_clave_sat: idBien,
                descripcion: descBien,
                cat_unidad: idUnidad,
                materialPeligroso: this.FormMercancia.get('mPeligroso').value == 2 ? true : false,
                CveMaterialPeligroso: cvePeligroso ? cvePeligroso.toString() : null,
                cat_embalaje: this.FormMercancia.get('emabalaje').value == 0 ? null : this.FormMercancia.get('emabalaje').value,
                pesoKg: this.FormMercancia.get('pesokg').value || 0,
                valorMercancia: this.FormMercancia.get('valorM').value == '' ? null : this.FormMercancia.get('valorM').value,
                dimenciones: this.FormMercancia.get('Dimen').value || null,
                cat_moneda: this.FormMercancia.get('moneda').value == '' ? null : this.FormMercancia.get('moneda').value,
                FraccionArancelaria: this.FormMercancia.get('fArancelaria').value,
                uuidComercio: this.FormMercancia.get('uuidComercio').value,
                fac_porte_mer_cantidads: null,
                fac_porte_mer_idens: null,
                fac_porte_pedimentos: this.pedimentosIds || null
            }
        };
        //console.log("🚀 ~ MercanciasComponent ~ saveMercancia ~ bodyMercancia:", bodyMercancia)

        if (this.idMercancia > 0) {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.putService(`fac-porte-mercancias/${this.idMercancia}`, bodyMercancia).subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                } else {

                    this.insExtras(this.idMercancia);

                    setTimeout(async () => {
                        const rm = await this.getMercancias();
                    }, 800);

                    setTimeout(() => {
                        this.FormMercancia.controls['mercancia'].setValue(this.idMercancia);
                        this._snackBar.open("Registro Actualizado", 'Ok', { duration: 10000 });
                    }, 900);
                    //return this._snackBar.open("Registro Actualizado", 'Ok', { duration: 10000 });
                }
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    this.store.dispatch(OcultarSpinner());
                });

        } else {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.postService('fac-porte-mercancias', bodyMercancia).subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                } else {

                    this.idMercancia = res.data.id;
                    this.insExtras(this.idMercancia);

                    const idMercancias = []

                    this.mercancias.forEach(element => {
                        idMercancias.push(element.id)
                    });

                    idMercancias.push(this.idMercancia)

                    const bodyActualizacion = {
                        fac_porte_mercancias: idMercancias
                    }
                    this.srvcoal.putService(`ope-empresas/${this.idEmpresa}`, { data: bodyActualizacion }).subscribe(
                        (res3: any) => {
                            if (!res3.err) {
                            }
                        },
                        (error) => {
                        }
                    );
                    
                    setTimeout(async() => {                      
                        const rm = await this.getMercancias();
                    }, 800);

                    setTimeout(() => {
                        this.FormMercancia.controls['mercancia'].setValue(this.idMercancia);                      
                        this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 })
                    }, 900);
                    //this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 })
                  
                }
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    this.store.dispatch(OcultarSpinner());
                });
        }

    }

    insExtras(id) {
        for (var i = 0; i <= this.guiaidentificacionlist.length - 1; i++) {
            // this.guiaidentificacionlist[0].identificacion.idMercancia = id;
            this.insIdentificacion(this.guiaidentificacionlist[i].identificacion);
        }
        for (var i = 0; i <= this.guiatransportelist.length - 1; i++) {
            // this.guiatransportelist[0].transporte.idMercancia = id;
            this.insTransporte(this.guiatransportelist[i].transporte);
        }
    }

    insIdentificacion(data) {
        let body = {
            data: {
                numeroGuiaIdentificacion: data.numero.toString(),
                descripGuiaIdentificacion: data.descripcion.toString(),
                pesoGuiaIdentificacion: data.peso
            }
        }
        this.srvcoal.postService('fac-porte-mer-idens', body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {
                const id: any = res.data.id
                this.idsIdentificacion.push(id)
                let bodyActualizaMercancia = {
                    data: {
                        fac_porte_mer_idens: this.idsIdentificacion
                    }

                }
                this.srvcoal.putService(`fac-porte-mercancias/${this.idMercancia}`, bodyActualizaMercancia).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {


                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });
            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    insTransporte(data) {
        let body = {
            data: {
                cantidad: data.cantidad,
                IDOrigen: data.idorigen?.toString(),
                IDDestino: data.iddestino?.toString()
            }
        }

        this.srvcoal.postService('fac-porte-mer-cantidades', body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(
                    MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                );
            } else if (res.excepcion) {
                this.store.dispatch(
                    MostrarExcepcion({
                        pila: res.excepcion,
                        tipoExcepcion: 3,
                    })
                );
            } else {

                const id: any = res.data.id
                this.idsTransporte.push(id)
                let bodyActualizaMercancia = {
                    data: {
                        fac_porte_mer_cantidads: this.idsTransporte
                    }

                }
                this.srvcoal.putService(`fac-porte-mercancias/${this.idMercancia}`, bodyActualizaMercancia).subscribe(async (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {


                    }
                },
                    (error: any) => {
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                        this.store.dispatch(OcultarSpinner());
                    });

            }
        },
            (error: any) => {
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );
                this.store.dispatch(OcultarSpinner());
            });
    }

    //Funciones para Guias
    //Agregar formulario
    addGuiaI = () => {
        this.countGuiasI.push({ id: `Guias Idenfificacion ${this.countGuiasI.length + 1}` });
        this.countGuiasI.length <= 0 ? this.removeDisabledGuiaI = true : this.removeDisabledGuiaI = false;
    };

    //Remover formulario
    removeGuiaI = () => {
        localStorage.removeItem('Guias Idenfificacion ' + this.countGuiasI.length);
        this.countGuiasI.splice(-1);
        this.countGuiasI.length <= 0 ? this.removeDisabledGuiaI = true : this.removeDisabledGuiaI = false;
    };

    FormGuiaIdentificacionEventEmiter = async (e) => {
        var bandera = false;
        if (this.guiaidentificacionlist.length > 0) {
            for (var i = 0; i <= this.guiaidentificacionlist.length - 1; i++) {
                if (this.guiaidentificacionlist[i].title == e.title) {
                    this.guiaidentificacionlist[i] = e;
                    bandera = true;
                }
            }
        }
        if (!bandera) {
            this.guiaidentificacionlist.push(e);
        }
    };

    //Funciones transporte
    //Agregar formulario
    addTransporte = () => {
        this.countTransporte.push({ id: `Cantidad Transporta ${this.countTransporte.length + 1}` });
        this.countTransporte.length <= 0 ? this.removeDisabledTransporte = true : this.removeDisabledTransporte = false;
    };
    //Remover formulario
    removeTransporte = () => {
        localStorage.removeItem('Cantidad Transporta ' + this.countTransporte.length);
        this.countTransporte.splice(-1);
        this.countTransporte.length <= 0 ? this.removeDisabledTransporte = true : this.removeDisabledTransporte = false;
    };

    FormGuiaTransporteEventEmiter = async (e) => {
        var bandera = false;
        if (this.guiatransportelist.length > 0) {
            for (var i = 0; i <= this.guiatransportelist.length - 1; i++) {
                if (this.guiatransportelist[i].title == e.title) {
                    this.guiatransportelist[i] = e;
                    bandera = true;
                }
            }
        }
        if (!bandera) {
            this.guiatransportelist.push(e);
        }
    };
    //Funciones pedimentos
    //Agregar
    addGuiaP(ped: IPartePedimento = this.defualtPedimento) {
        let num = (this.countGuiasP.length + 1);
        ped.index = `PartePedimento${num}`;
        ped.title = `Pedimento ${num}`;
        this.countGuiasP.push(ped);
        this.countGuiasP.length <= 0 ? this.removeDisabledGuiaP = true : this.removeDisabledGuiaP = false;
    }
    removeGuiaP() {
        //localStorage.removeItem('Pedimento ' + this.countGuiasP.length);
        this.countGuiasP.splice(-1);
        this.countGuiasP.length <= 0 ? this.removeDisabledGuiaP = true : this.removeDisabledGuiaP = false;
    }
    //Eliminar
    //Enviar data para guardar factura
    senddata() {
        this.FormMercancia.statusChanges.subscribe(status => {
            if (this.FormMercancia.valid) {
                let data = { idMercancia: this.idMercancia, title: this.title }
                this.FormMercanciaEventEmiter.emit(data);
            }
        });
    }

    savePortePedimento(pedimento: string = ''): Promise<boolean> {
        return new Promise<boolean>(resolve => {

            let data = {
                data: {
                    pedimento: pedimento
                }
            };

            this.srvcoal.postService('fac-porte-pedimentos', data).subscribe((res: any) => {
                if (res?.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res?.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }));
                } else {
                    let result = res?.data || { id: 0 };
                    if (result?.id > 0) {
                        this.pedimentosIds.push(result.id);
                    }
                }

                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });

        });

    }

    updatePortePedimento(id: number = 0, pedimento: string = ''): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let data = {
                data: {
                    pedimento: pedimento,
                }
            };

            this.srvcoal.putService(`fac-porte-pedimentos/${id}`, data).subscribe((res: any) => {

                if (res?.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res?.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }));
                } else {
                    let result = res?.data || { id: 0 };
                    if (result?.id > 0) {
                        this.pedimentosIds.push(result.id);

                    }
                }
                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });

        });
    }

    logicalDeletePortePedimento(id: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let model = {
                data: { publishedAt: null }
            };
            this.srvcoal.putService(`fac-porte-pedimentos/${id}`, model).subscribe(async (res: any) => {
                resolve(true);
            },
                (error: any) => {
                    console.error(error);
                    resolve(false);
                });

        });
    }

    asignarExtrasGuiasP(pedimentos: any[] = []) {
        this.countGuiasP = [];
        this.pedimentosList = [];
        this.pedimentosIds = [];
        for (const { id, attributes } of pedimentos) {
            let idPend = id || 0;
            let namePend = attributes?.pedimento || '';
            if (idPend > 0) {
                let element: IPartePedimento = { index: '', id: idPend, pedimento: namePend, title: '' };
                this.addGuiaP(element);
            }
        }
    }


    getProductoServicio(value) {

        let nombre = String(value || '');
        if (nombre !== null && nombre !== '') {

            if (nombre.length < 4) {
                this._snackBar.open('Favor de ingresar al menos 4 caracteres', 'OK', { duration: 5000 });
                return false;
            }
            this.myControl.enable();
            this.store.dispatch(MostrarSpinner());
            //this.srvcoal.getService(`cat-unidad/filter?nombre=${nombre}&pagination[start]=0&pagination[limit]=54000`)
            this.srvcoal.getService(`clave-sat/filter?descripcion=${nombre}&pagination[start]=0&pagination[limit]=54000`)
                .subscribe(
                    (res: any) => {
                        console.log("🚀 ~ MercanciasComponent ~ getProductoServicio ~ res:", res)

                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4, }));
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                        } else {
                            this.optionSAT = res?.data || [];
                            this.claveSAT = res?.data || [];
                            if (this.optionSAT.length == 0) {
                                this._snackBar.open(
                                    'No se encontraron resultados con tu busqueda, favor de intentar nuevamente.',
                                    'OK',
                                    { duration: 5000 }
                                );
                            } else {
                                this.rowsetshowClave = true;
                                //myInputClave
                                setTimeout(() => {
                                    //this.myInputClave.nativeElement.focus();
                                    var element = this.renderer.selectRootElement('#myInputClave');
                                    element.focus();
                                }, 500);
                            }
                        }

                    },
                    (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    }
                );
        }
    }

    GetSelUnidadMedia(value) {
        let nombre = String(value || '');

        if (nombre !== null && nombre !== '') {
            if (nombre.length < 2) {
                this._snackBar.open('Favor de ingresar al menos 2 caracteres', 'OK', { duration: 5000 });
                return false;
            }

            this.myControlUnidadMedida.enable();
            this.store.dispatch(MostrarSpinner());            
            this.srvcoal.getService(`cat-unidad/filter?nombre=${nombre}&pagination[start]=0&pagination[limit]=54000`)
                .subscribe(
                    (res: any) => {
                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4, }));
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                        } else {
                            this.unidadMedida = res?.data || [];
                            this.unidad_Medida = res?.data || [];
                            if (this.unidadMedida.length == 0) {
                                this._snackBar.open(
                                    'No se encontraron resultados con tu busqueda, favor de intentar nuevamente.',
                                    'OK',
                                    { duration: 5000 }
                                );
                            } else {
                                this.rowsetshowUnidad = true;
                                setTimeout(() => {
                                    var element =
                                        this.renderer.selectRootElement(
                                            '#myInputUnidad'
                                        );
                                    element.focus();
                                }, 500);
                            }

                        }
                    },
                    (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    }
                );
        }
    }
}
